"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyType = exports.TrackerType = exports.Provenance = void 0;
exports.Provenance = {
    first: 'first',
    third: 'third',
    mixed: 'mixed',
};
exports.TrackerType = {
    cookie: 'cookie',
    localStorage: 'localStorage',
    sessionStorage: 'sessionStorage',
};
exports.PropertyType = {
    web: 'web',
    mobile: 'mobile',
    ctv: 'ctv',
    android: 'android',
    ios: 'ios',
    other: 'other',
};
